import { breadcrumbAnatomy as parts } from "@chakra-ui/anatomy"
import type { ComponentStyleConfig } from "@chakra-ui/theme"

export const Breadcrumb: ComponentStyleConfig = {
  parts: parts.keys,
  baseStyle: {
    item: {
      fontSize: 14,
    },
    separator: {
      mx: 1,
    },
  },
}
